import React from 'react';

import { Button } from './GoogleSignInButton.styles';

export type GoogleSignInButtonProps = React.HTMLAttributes<HTMLButtonElement>;

function GoogleSignInButton(props: GoogleSignInButtonProps) {
  return (
    <Button {...props}>
      <div className="icon">
        <img src="images/google-icon.svg" />
      </div>
      <div className="text">Sign in with Google</div>
    </Button>
  );
}

export default GoogleSignInButton;
